export interface Status {
  id: string
  code: string
  name: string
  color: string
  icon: string | null
  is_terminal: boolean
}

export function StatusBadge({ status }: { status: Status }) {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-md text-white"
      style={{ backgroundColor: status.color }}
    >
      {status.name}
    </span>
  )
}
